import React, { useState } from "react";
import "./styles.css";

var animalLibrary = {
  "🐵": "Monkey",
  "🦁": "Lion",
  "🐶": "Dog",
  "🐭": "Rat",
  "🐎": "Horse",
  "🐇": "Rabbit",
  "🦍": "Gorilla",
  "🐺": "Wolf",
  "🐂": "Ox",
  "🐪": "Camel",
  "🐘": "Elephant"
};

var animalList = Object.keys(animalLibrary);

export default function App() {
  const [animal, setAnimal] = useState("");

  function readanimalHandler(event) {
    var userValue = event.target.value;
    if (userValue in animalLibrary) {
      setAnimal(animalLibrary[userValue]);
    } else {
      setAnimal("We don't have this in our Database");
    }
  }

  function emojiClickHandler(emoji) {
    var meaning = animalLibrary[emoji];
    setAnimal(meaning);
  }

  return (
    <div className="App">
      <h1>animalship</h1>
      <input onChange={readanimalHandler}></input>
      <div className="txt-output">{animal}</div>

      {animalList.map(function (emoji) {
        return (
          <span onClick={() => emojiClickHandler(emoji)} className="emojiList">
            {emoji}
          </span>
        );
      })}
    </div>
  );
}
